<template>
  <div class="row justify-content-center">
    <!-- TODO: remove row/col classes before placing in mst.dk context -->
    <div class="list-products col-md-6" role="main">
      <h1 class="page-title">
        {{ $store.state.products.content.ListProducts.title }}
      </h1>
      <h5>{{ $store.state.products.content.ListProducts.subTitle }}</h5>

      <CategoryPanel
        @filtersUpdated="
          updateProducts({
            goToFirstPage: true,
            scrollToTop: false,
            scrollToList: true,
          })
        "
        :isWindowSmall="isWindowSmall"
        :productCategories="
          sortCategoryNames($store.state.products.categoryNames)
        "
      />

      <SearchFunction
        :placeholder="
          $store.state.products.content.ListProducts.placeholderSearch
        "
        @searchUpdated="
          updateProducts({
            goToFirstPage: true,
            scrollToTop: false,
            scrollToList: false,
          })
        "
        style="margin: 50px 0px 0px 0px"
      />
      <FilterModal
        v-if="isWindowSmall"
        :title="$store.state.products.content.ListProducts.filterModalTitle"
        :btnText="$store.state.products.content.ListProducts.saveFiltersTitle"
        :isWindowSmall="isWindowSmall"
        :clearFiltersTitle="
          $store.state.products.content.ListProducts.clearFiltersTitle
        "
        @filtersUpdated="
          updateProducts({
            goToFirstPage: true,
            scrollToTop: false,
            scrollToList: false,
          })
        "
      >
        <FilterPanel
          :filterReactionTitle="
            $store.state.products.content.ListProducts.filterReactionTitle
          "
          :productReactions="$store.state.products.reactionNames"
          :filterCategoryTitle="
            $store.state.products.content.ListProducts.filterCategoryTitle
          "
          :productCategories="
            sortCategoryNames($store.state.products.categoryNames)
          "
          @filtersUpdated="
            updateProducts({
              goToFirstPage: true,
              scrollToTop: false,
              scrollToList: false,
            })
          "
          :isWindowSmall="isWindowSmall"
          :clearFiltersTitle="
            $store.state.products.content.ListProducts.clearFiltersTitle
          "
        />
      </FilterModal>

      <ReadMore
        style="margin-top: 20px"
        :htmlText="$store.state.products.content.ListProducts.description"
      />

      <FilterPanel
        v-if="!isWindowSmall"
        :filterReactionTitle="
          $store.state.products.content.ListProducts.filterReactionTitle
        "
        :productReactions="$store.state.products.reactionNames"
        :filterCategoryTitle="
          $store.state.products.content.ListProducts.filterCategoryTitle
        "
        :productCategories="
          sortCategoryNames($store.state.products.categoryNames)
        "
        @filtersUpdated="
          updateProducts({
            goToFirstPage: true,
            scrollToTop: false,
            scrollToList: false,
          })
        "
        :isWindowSmall="isWindowSmall"
        :clearFiltersTitle="
          $store.state.products.content.ListProducts.clearFiltersTitle
        "
      />

      <FetchError v-if="fetchError" class="mt-5" />
      <ProductCardList
        v-else
        :productCards="productCards"
        :loading="loadingProducts"
        :isWindowSmall="isWindowSmall"
      />

      <div
        class="pagination-container d-flex justify-content-center"
        v-if="productCards.length > 0 && !loadingProducts"
      >
        <VPagination
          v-model="page"
          :pages="getNumberPages"
          :range-size="1"
          @update:modelValue="
            updateProducts({
              goToFirstPage: false,
              scrollToTop: false,
              scrollToList: true,
            })
          "
          :hideFirstButton="true"
          :hideLastButton="true"
          v-if="getNumberPages > 1"
        />
      </div>

      <NoResultsBox
        :title="
          $store.state.products.content.ListProducts.noSearchResults.title
        "
        :subTitle="
          $store.state.products.content.ListProducts.noSearchResults.subTitle
        "
        :body="$store.state.products.content.ListProducts.noSearchResults.body"
        :loading="loadingProducts"
        v-else-if="
          !(productCards.length > 0) &&
          ($store.state.products.searchTerm ||
            $store.state.products.filtersInput.reactionFilters.length > 0 ||
            $store.state.products.filtersInput.categoryFilters.length > 0)
        "
      />
    </div>
  </div>
  <BackToTopBtn :btnText="$store.state.products.content.backToTopBtnText" />
</template>

<script>
import ProductCardList from "@/components/products/ProductCardList.vue";
import VPagination from "@hennge/vue3-pagination";
import getFilters from "@/composables/getFilters";
import SearchFunction from "@/components/products/SearchFunction.vue";
import FilterPanel from "@/components/products/FilterPanel.vue";
import FilterModal from "@/components/products/FilterModal.vue";
import axios from "axios";
import BackToTopBtn from "@/components/widgets/BackToTopBtn.vue";
import FetchError from "@/components/FetchError.vue";
import NoResultsBox from "@/components/products/NoResultsBox.vue";
import ReadMore from "@/components/widgets/ReadMore.vue";
import CategoryPanel from "@/components/products/CategoryPanel.vue";
import { useStore } from "vuex";
import { ref } from "vue";

async function getReactionNames() {
  const {
    filterData: reactionNames,
    error: errorReactionNames,
    load: loadReactionNames,
  } = getFilters("reaction/mst");

  await loadReactionNames().then(() => {
    if (errorReactionNames.value) {
      console.log(errorReactionNames.value);
    }
  });

  return { reactionNames };
}

async function getCategoryNames() {
  const {
    filterData: categoryNames,
    error: errorCategoryNames,
    load: loadCategoryNames,
  } = getFilters("product-category-type/mst");

  await loadCategoryNames().then(() => {
    if (errorCategoryNames.value) {
      console.log(errorCategoryNames.value);
    }
  });

  return { categoryNames };
}

export default {
  name: "ListProducts",
  components: {
    ProductCardList,
    VPagination,
    SearchFunction,
    FilterPanel,
    FilterModal,
    BackToTopBtn,
    FetchError,
    NoResultsBox,
    ReadMore,
    CategoryPanel,
  },
  data() {
    return {
      csvData: "",
      isWindowSmall: true,
      fetchError: false,
      loadingProducts: false,
    };
  },
  setup() {
    const store = useStore();

    if (Object.keys(store.state.products.reactionNames).length === 0) {
      let reactionNames = ref({});

      getReactionNames().then((data) => {
        reactionNames.value = data.reactionNames.value;
        store.commit("products/setReactionNames", {
          reactionNames: reactionNames,
        });
      });
    }

    if (Object.keys(store.state.products.categoryNames).length === 0) {
      let categoryNames = ref({});

      getCategoryNames().then((data) => {
        categoryNames.value = data.categoryNames.value;
        store.commit("products/setCategoryNames", {
          categoryNames: categoryNames,
        });
      });
    }

    return {};
  },
  watch: {
    productCards() {
      this.loadingProducts = false;
    },
  },
  mounted() {
    window.addEventListener("resize", this.evaluateWindowSize);
    this.evaluateWindowSize();
    // This destroys functionality of clicking on category in ProductInfo
    // if (!this.$store.state.products.productCards.length > 0) {
    this.updateProducts({
      goToFirstPage: true,
      scrollToTop: true,
    });
    // }
  },
  updated() {
    this.$nextTick(function () {
      // Scroll to list view when
      // entire view has been re-rendered
      // if a product has been viewed previously
      if (Object.keys(this.$store.state.products.productCard).length > 0) {
        if (document.getElementsByClassName("product-card-list")[0]) {
          const offset = document.getElementsByClassName("product-card-list")[0]
            .offsetTop;
          window.scrollTo({ top: offset, behavior: "smooth" });
        }
      }
    });
  },
  unmounted() {
    window.removeEventListener("resize", this.evaluateWindowSize);
  },
  methods: {
    sortCategoryNames(array) {
      let lookup = this.$store.state.products.categoryImages;
      let sortedArray = [];
      if (lookup.length > 0) {
        lookup.forEach((lookupElement) => {
          if (array.length > 0) {
            array.forEach((arrayElement) => {
              if (arrayElement.name_d) {
                if (
                  arrayElement.name_d
                    .toLowerCase()
                    .includes(lookupElement.category.toLowerCase())
                ) {
                  sortedArray.push(arrayElement);
                }
              }
            });
          }
        });
      }

      if (array.length > 0 && sortedArray.length > 0) {
        let noMatchArray = array.filter(
          (value) => !sortedArray.includes(value)
        );
        if (noMatchArray.length > 0) {
          sortedArray.push(...noMatchArray);
        }
      }

      return sortedArray;
    },
    getDisplayName(wzCode, dict) {
      if (!(Object.keys(dict).length === 0)) {
        for (const [key, value] of Object.entries(dict)) {
          if (value.wzCodes.includes(wzCode)) {
            return key;
          }
        }
      } else {
        return wzCode;
      }
    },
    evaluateWindowSize() {
      this.isWindowSmall = window.innerWidth < 768;
    },
    updateProducts(event) {
      this.loadingProducts = true;
      if (event.goToFirstPage) {
        this.page = 1;
      }
      if (event.scrollToTop) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      if (event.scrollToList) {
        const offset = document.getElementsByClassName("product-card-list")[0]
          .offsetTop;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
      const callObject = JSON.stringify({
        page: this.page,
        pageSize: this.productsPerPage,
        searchText: this.$store.state.products.searchTerm,
        productCategoryTypeIds: this.parseStrings(
          this.$store.state.products.filtersInput.categoryFilters
        ),
        reactionIds: this.parseStrings(
          this.$store.state.products.filtersInput.reactionFilters
        ),
      });

      console.log(callObject);

      axios
        .post(
          process.env.VUE_APP_PRODUCTS_API + "product/search/mst",
          callObject,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          console.log(
            "Response from " + process.env.VUE_APP_PRODUCTS_API,
            response
          );
          this.totalNumberProducts = response.data.rowCount;
          this.productCards = response.data.results;
        })
        .catch((error) => {
          console.log(
            "Response from " + process.env.VUE_APP_PRODUCTS_API,
            error
          );
          this.fetchError = true;
        });
    },
    parseStrings(stringArray) {
      let numberArray = [];
      if (stringArray.length > 0) {
        stringArray.forEach((element) => {
          numberArray.push(Number(element));
          // The below has been left here in case it will be needed at a later point
          // if (element) {
          //   element.split(",").map((item) => numberArray.push(Number(item)));
          // }
        });
      }
      return numberArray;
    },
  },
  computed: {
    getNumberPages() {
      return Math.ceil(this.totalNumberProducts / this.productsPerPage);
    },
    page: {
      get() {
        return this.$store.state.products.page;
      },
      set(value) {
        this.$store.commit("products/setPage", { page: value });
      },
    },
    totalNumberProducts: {
      get() {
        return this.$store.state.products.totalNumberProducts;
      },
      set(value) {
        this.$store.commit("products/setTotalNumberProducts", {
          totalNumberProducts: value,
        });
      },
    },
    productCards: {
      get() {
        return this.$store.state.products.productCards;
      },
      set(value) {
        this.$store.commit("products/setProductCards", {
          productCards: value,
        });
      },
    },
    productsPerPage: {
      get() {
        return this.$store.state.products.productsPerPage;
      },
    },
    // reactionNames: {
    //   get() {
    //     return this.$store.state.products.reactionNames;
    //   },
    // },
    // categoryNames: {
    //   get() {
    //     return this.$store.state.products.categoryNames;
    //   },
    // },
  },
};
</script>

<style lang="scss">
.pagination-container .Pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.pagination-container .PaginationControl {
  display: flex;
  align-items: center;
}
.pagination-container .Control {
  position: relative;
  display: block;
  width: 26px;
  height: 22px;
  fill: var(--deepgreenopaque);

  &-active {
    fill: var(--deepgreen);
    cursor: pointer;
  }
  &-active:hover {
    color: var(--deepgreen);
    transform: scale(1.2);
  }
  &-active:focus {
    color: var(--deepgreen);
  }
}
.pagination-container .Page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin: 0 2px;
  color: var(--deepgreenopaque);
  background-color: var(--lightgreyopaque);
  border-radius: 3px;
  border-color: transparent;
  cursor: pointer;
  outline: 0;
  user-select: none;
  font-family: oxygen-bold;
  font-size: 1em;

  &-active {
    color: var(--deepgreen);
    background-color: transparent !important;
  }
  &:hover {
    color: var(--deepgreen);
    transform: scale(1.2);
  }
  &:focus {
    color: var(--deepgreen);
  }
}
.pagination-container .DotsHolder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin: 0 2px;
}
.pagination-container .Dots {
  width: 12px;
  fill: var(--deepgreen);
}
.pagination-container li {
  background-color: var(--lightgrey);
  padding: 10px;
  margin: 5px;
}
</style>
